import './WidgetTemplatesTable.css';

import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import { Add, CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import B2BTableInMemory from '../../../b2b-common/B2BTableInMemory';

const WidgetTemplatesTable = ({ templates = [], onNewTemplate, onSelect, ...rest }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    const headers = [
        { label: t('Acronym'), align: 'center' },
        { label: t('Template name'), align: 'left' },
        { label: t('Description'), align: 'left' },
        { label: t('Scope'), align: 'center' },
        { label: t('Enabled'), align: 'center' },
    ];

    const rows = templates ? templates.map((template) => ({
        id: template.id,
        cells: [
            { content: template.acronym, align: 'center' },
            { content: template.name, align: 'left' },
            { content: template.description, align: 'left' },
            { content: template.scope, align: 'center' },
            { content: template.isEnabled ? <CheckBox /> : <CheckBoxOutlineBlank />, align: 'center' },
        ],
    })) : [];

    const handleSelectTemplate = (rowSelected) => {
        const selectedTemplate = templates.find((template) => template.id === rowSelected.id);
        onSelect && onSelect(selectedTemplate);
    }

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            className={'widget-templates-table'}
            numRows={10}
            stickyHeader={true}
            onRowClick={handleSelectTemplate}
            buttons={[
                { label: t('New template'), icon: <Add />, onClick: onNewTemplate }
            ]}
            {...rest}
        />
    );

}

export default WidgetTemplatesTable;